import { FormControlLabel, Switch } from "@mui/material";
import type { FieldValues } from "react-hook-form";
import { Controller } from "react-hook-form";
import type { FormComponentProps } from "./FormComponentProps";

type FormSwitchProps<TFieldValues extends FieldValues = FieldValues> = FormComponentProps<TFieldValues>;

function FormSwitch<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  disabled,
}: FormSwitchProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          control={<Switch checked={value} onChange={onChange} name={name} disabled={disabled} />}
          label={label}
          disabled={disabled}
        />
      )}
    />
  );
}

export default FormSwitch;
